module.exports = __webpack_public_path__ + "src/assets/img/s-share.5f25418c.svg";